/* eslint-disable @typescript-eslint/no-explicit-any */
import vueAuth0, { FetchUser } from "@voodoo.io/vue-auth0";

import config from "@/config";
import { GRAPHQL_ERROR_FORBIDDEN, GRAPHQL_ERROR_UNAUTHENTICATED } from "@/graphql/constants";

export interface User {
  id: string;
  firstName: string;
  lastName: string;
  name: string;
  nickname: string;
  email: string;
  picture: string | null;
  permissions: { id: string; description: string }[];
}

const authQuery = `
    query {
        currentUser {
            id
            name
            nickname
            email
            picture
            permissions {
                id
                description
            }
        }
    }
    `;

const fetchUser: FetchUser<User> = async (accessToken: string) => {
  const response = await fetch(config.graphqlEndpointUrl, {
    method: "POST",
    headers: { "content-type": "application/json", Authorization: `Bearer ${accessToken}` },
    body: JSON.stringify({ query: authQuery }),
  });

  type JSONResponse = {
    data?: {
      currentUser: User;
    };
    errors?: { message: string }[];
  };

  const { data, errors }: JSONResponse = await response.json();
  if (errors && errors.length) {
    const hasAuthenticationError = errors.some(
      (error: any) => error.extensions?.code === GRAPHQL_ERROR_UNAUTHENTICATED
    );
    if (hasAuthenticationError) {
      throw new Error("AUTHENTICATION_ERROR");
    }

    const isForbiddenError = errors.some((error: any) => error.extensions?.code === GRAPHQL_ERROR_FORBIDDEN);
    if (isForbiddenError) {
      throw new Error("FORBIDDEN_ERROR");
    }
    console.error(errors);
    throw new Error(errors.join("\n"));
  }

  const user = data?.currentUser ?? null;
  const permissions = data?.currentUser.permissions.map(({ id }) => id) || [];
  return { user, permissions };
};

const accessTokenStorageKey = `${config.localStoragePrefix ?? ""}-${config.environment}-voodoo-app-access-token`;

export default vueAuth0<User>({
  loginUrl: "/login",
  auth0LogoutRedirectUrl: config.auth0.logoutRedirectUrl,
  auth0Domain: config.auth0.domain,
  auth0ClientId: config.auth0.clientId,
  auth0CallbackRedirectUrl: config.auth0.callbackRedirectUrl,
  auth0Audience: config.auth0.audience,
  accessTokenStorageKey,
  fetchUser,
});
